import { useState } from 'react'
import SaveButton from '../Buttons/SaveButton'
import { useInteractionContext } from '../../context/InteractionContext'
import { ProjectEconomySaveModal } from './ProjectEconomySaveModal/ProjectEconomySaveModal'

interface SaveProjectEconomyProps {
  edited: boolean
}

const SaveProjectEconomy = ({ edited }: SaveProjectEconomyProps) => {
  const { refreshLoading } = useInteractionContext()

  const [isSaveModalOpen, setIsSaveModalOpen] = useState<boolean>(false)
  const handleOnSaveClick = () => setIsSaveModalOpen(true)

  const tooltip = refreshLoading ? 'Laddas...' : 'Projektekonomin sparad'

  return (
    <>
      <SaveButton
        text={'Spara projektekonomi'}
        handleOnSaveClick={handleOnSaveClick}
        disabled={!edited}
        tooltip={tooltip}
      />

      <ProjectEconomySaveModal
        isOpen={isSaveModalOpen}
        onClose={() => setIsSaveModalOpen(false)}
      />
    </>
  )
}

export default SaveProjectEconomy
